import { AxiosPromise } from 'axios';
import axios from 'axios';
import { ITransferReq } from '../models/studentsMoveCampus.model';

const uri = '/mgmt/students/move-campus';

export const generateCode = (data: ITransferReq): AxiosPromise => {
  return axios.post(`${uri}/create`, data);
};

export const confirmCode = (data: ITransferReq): AxiosPromise => {
  return axios.post(`${uri}/confirm`, data);
};

export const transferCampus = (data: ITransferReq): AxiosPromise => {
  return axios.post(`${uri}/change-confirm`, data);
};
